<ion-header class="extendido extendido-min">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Filtrar' | translate}}
      {{(getNomenclatura(tipo) | nomenclatura | async)}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-card-content>
    <form class="sample-form validations-form" [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)">
      <ion-list>
        <ion-row>
          <ion-col size="12" class="remove-border ion-padding-bottom">
            <ion-item>
              <ion-select 
                labelPlacement="stacked"
                interface="action-sheet"
                label="{{'Dia da Semana' | translate}}"
                placeholder="{{'Dia da Semana' | translate}}"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="dia"
              >
                <ion-select-option *ngFor="let semana of diaSemanaList" [value]="semana.id">{{semana.nome}}</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12" class="remove-border ion-padding-bottom">
            <ion-item>
              <ion-select 
                labelPlacement="stacked"
                interface="action-sheet"
                label="{{'Tipo' | translate}}"
                placeholder="{{'Tipo' | translate}}"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="tipo"
                (ionDismiss)="onCancel()"
              >
                <ion-select-option [value]="0 || null">{{'TODOS' | translate}}</ion-select-option>
                <ion-select-option *ngFor="let tipo of tipos" [value]="tipo.id">{{tipo.nome}}</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12" class="remove-border ion-padding-bottom">
            <ion-item>
              <ion-select 
                labelPlacement="stacked"
                interface="action-sheet"
                label="{{'Região' | translate}}"
                placeholder="{{'Região' | translate}}"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="regiao"
              >
                <ion-select-option [value]="0 || null">{{'TODOS' | translate}}</ion-select-option>
                <ion-select-option *ngFor="let regiao of regioes" [value]="regiao.id">{{regiao.nome}}</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <div class="down">
          <ion-button 
            class="btn-default"
            expand="block"
            type="submit"
          >
            {{'Filtrar' | translate }}
          </ion-button>
        </div>
      </ion-list>
    </form>
  </ion-card-content>
</ion-content>